"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _dicts = require("@package/dicts");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _Dates = _interopRequireDefault(require("./Dates"));

var _Periods = _interopRequireDefault(require("./Periods"));

var _Amount = _interopRequireDefault(require("./Amount"));

var _Search = _interopRequireDefault(require("./Search"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Filter(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid;

  try {
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['wrapper'],
      onSubmit: handleSubmit,
      "data-locator": "payouts.filter"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['date']
    }, /*#__PURE__*/_react["default"].createElement(_Dates["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['amount']
    }, /*#__PURE__*/_react["default"].createElement(_Amount["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['status']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      "data-locator": "status",
      clearable: false,
      simple: true,
      label: "\u0421\u0442\u0430\u0442\u0443\u0441",
      name: "status",
      options: _dicts.PAYOUT_STATUS_NAME
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line']
    }, /*#__PURE__*/_react["default"].createElement(_Periods["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['line']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['search']
    }, /*#__PURE__*/_react["default"].createElement(_Search["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checkbox']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.CheckboxField, {
      name: 'shopDemoMode'
    }, "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "payouts.filter.submit",
      type: "submit",
      mode: "primary",
      disabled: !valid
    }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Filter;
exports["default"] = _default;